<template>
  <iframe  src="static/5G_sc/5G_sc-.html" width="100%" height="1000px"></iframe>
</template>
<script>
    export default {
        name: "FiveG"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/supplychain/components/FiveG.vue